export default "__VITE_ASSET__f79e567b__"